import { render, staticRenderFns } from "./CreateNewPrintItemButton.vue?vue&type=template&id=ba7fc902&scoped=true&"
import script from "./CreateNewPrintItemButton.vue?vue&type=script&lang=js&"
export * from "./CreateNewPrintItemButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7fc902",
  null
  
)

export default component.exports